import { render, staticRenderFns } from "./df-page-error.vue?vue&type=template&id=1c8fa18e&"
import script from "./df-page-error.ts?vue&type=script&lang=js&"
export * from "./df-page-error.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports